import type { ThemeConfig } from "antd";

export const FONT_SANS =
  "'IBM Plex Sans','PingFang SC','HarmonyOS Sans SC','Microsoft YaHei','Noto Sans SC',sans-serif";

// 朱印运营台：纸白底、深墨文字、朱砂动作色。按钮底色用 #c13b28（白字 5.2:1），
// 品牌强调色 #d84430 只用于图标、选中标记与大字。
const theme: ThemeConfig = {
  token: {
    colorPrimary: "#c13b28",
    colorLink: "#c13b28",
    colorLinkHover: "#9f2f20",
    colorInfo: "#2f5b8c",
    colorSuccess: "#2f8d61",
    colorWarning: "#c0892b",
    colorError: "#c13b28",
    colorText: "#211b18",
    colorTextSecondary: "#5f554e",
    colorTextTertiary: "#756a62",
    colorTextQuaternary: "#958a81",
    colorTextPlaceholder: "#a89d93",
    colorBorder: "#d6ccc1",
    colorBorderSecondary: "#e5ddd4",
    colorSplit: "#efe9e2",
    colorBgLayout: "#fbfaf7",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorFillSecondary: "#f3eee8",
    colorFillTertiary: "#f7f3ee",
    colorFillQuaternary: "#fbfaf7",
    colorBgMask: "rgba(33, 27, 24, 0.32)",
    borderRadius: 8,
    borderRadiusSM: 6,
    borderRadiusLG: 14,
    fontSize: 14,
    controlHeight: 36,
    controlHeightSM: 30,
    controlHeightLG: 44,
    fontFamily: FONT_SANS,
    boxShadow: "0 12px 32px rgba(33, 27, 24, 0.12)",
    boxShadowSecondary: "0 12px 32px rgba(33, 27, 24, 0.12)",
    controlOutline: "rgba(33, 27, 24, 0.08)",
    controlOutlineWidth: 3,
    motionDurationMid: "0.16s",
  },
  components: {
    Button: {
      fontWeight: 600,
      primaryShadow: "none",
      defaultShadow: "none",
      dangerShadow: "none",
      defaultBorderColor: "#d6ccc1",
      defaultColor: "#211b18",
    },
    Table: {
      headerBg: "#f7f3ee",
      headerColor: "#756a62",
      headerSplitColor: "transparent",
      rowHoverBg: "#fff7f3",
      rowSelectedBg: "#fff7f4",
      rowSelectedHoverBg: "#fff0ec",
      borderColor: "#efe9e2",
      cellPaddingInline: 16,
      cellPaddingBlock: 14,
    },
    Modal: { titleFontSize: 19, borderRadiusLG: 16 },
    Drawer: { colorBgElevated: "#fbfaf7" },
    Tabs: { inkBarColor: "#d84430", itemSelectedColor: "#211b18", itemColor: "#5f554e", itemHoverColor: "#211b18" },
    Segmented: { itemSelectedColor: "#211b18", trackBg: "#f3eee8" },
    Select: { optionSelectedBg: "#fff0ec", optionSelectedColor: "#211b18" },
    Dropdown: { controlItemBgHover: "#f7f3ee" },
    Message: { contentPadding: "10px 16px" },
  },
};

export default theme;
